import {Component, Input} from '@angular/core';
import {FileAttachmentApiService, KnowledgeDocument, KnowledgeDocumentType} from '@npck/af-frontend-api';
import {RouterService, downloadFromBlobResponse, rxSpinner} from '@npck/libs/commons';
import {Path} from '../../../../path';

@Component({
    selector: 'af-knowledge-document-items',
    templateUrl: './knowledge-document-items.component.html',
    standalone: false,
})
export class KnowledgeDocumentItemsComponent {
    @Input() documents: KnowledgeDocument[] = [];

    KnowledgeDocumentType = KnowledgeDocumentType;

    constructor(
        private fileAttachmentApiService: FileAttachmentApiService,
        private routerService: RouterService,
    ) {}

    openDocument(doc: KnowledgeDocument): void {
        if (doc.type === KnowledgeDocumentType.DOCUMENT) {
            const file = doc.attachedDocument!.files[0];
            const isPdf = file.name?.toLowerCase().endsWith('.pdf');
            this.fileAttachmentApiService.downloadFile(file.id!, 'response')
                .pipe(rxSpinner('download-' + doc.id))
                .subscribe(response => {
                    if (isPdf) {
                        const blobUrl = URL.createObjectURL(response.body!);
                        this.routerService.navigate(Path.KNOWLEDGE_BASE_DOC_VIEW, {
                            state: {blobUrl, documentName: doc.name},
                        });
                    } else {
                        downloadFromBlobResponse(response);
                    }
                });
        } else {
            window.open(doc.link!, '_blank');
        }
    }
}
